module.exports = __webpack_public_path__ + "static/media/banner-2.dc7a4ffb.jpeg";